module.exports = __webpack_public_path__ + "static/buckwoodcover-d7d9e97c6946eab304277fa1ed38135c.jpg";